import { render, staticRenderFns } from "./AssessmentRecords.vue?vue&type=template&id=3b1c8459&scoped=true"
import script from "./AssessmentRecords.vue?vue&type=script&lang=js"
export * from "./AssessmentRecords.vue?vue&type=script&lang=js"
import style0 from "./AssessmentRecords.vue?vue&type=style&index=0&id=3b1c8459&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1c8459",
  null
  
)

export default component.exports